import React from "react";
import { Scrollbars } from "react-custom-scrollbars-2";

import SideContentBlock from "../../../shared/sideContentBlock";

import SideContentInner from "../../../shared/sideContentInner";
import ReportHistoryContentTitle from "../reports/reportHistoryContentTitle";
import ListSavedReportsWrapper from "../reports/listSavedReportsWrapper";
import SavedReportsPaginationWrapper from "../reports/savedReportsPaginationWrapper";

import styles from "./savedReports.module.scss";

const SavedReports = () => {
  return (
    <Scrollbars style={{ height: "100%" }} autoHide={true}>
      <div className={styles.savedReports}>
        <div className={styles.savedReports_container}>
          <SideContentBlock>
            <ReportHistoryContentTitle />
            <div className={styles.savedReportsWrapper}>
              <SideContentInner>
                <div className={styles.container_savedReports}>
                  <div className={styles.container_savedReportsList}>
                    <ListSavedReportsWrapper />
                  </div>
                  <div className={styles.container_savedReportsPagination}>
                    <SavedReportsPaginationWrapper />
                  </div>
                </div>
              </SideContentInner>
            </div>
          </SideContentBlock>
        </div>
      </div>
    </Scrollbars>
  );
};

export default React.memo(SavedReports);
